import { AxiosResponse } from 'axios';
import { api } from './api/api';

export async function getDetailsMinasAtivas<T>(processo_ano: string[]) {
  const query = processo_ano.map(p => `processo_ano=${p}`).join("&");

  const response: AxiosResponse<T> = await api.get(
    `/detalhes-minas-ativas/?${query}`,
  );

  return response;
}
